import { useEffect, useState } from 'react';

import { useSearch } from '@backstage/plugin-search-react';
import AllIcon from '@material-ui/icons/FontDownload';
import { CatalogIcon } from '@backstage/core-components';
import CustomSearchFilter from './CustomSearchFilter';
import {
  accordionData,
  EnterpriseResultSet,
  SearchAccordionProps,
} from './types';

/**
 * A component that provides a filter for sources.
 * @param props - see {@link SearchAccordionProps}.
 * @public
 */
export const SearchSourcesAccordion = (props: SearchAccordionProps) => {
  const { filters, setFilters, setPageCursor, result, term } = useSearch();
  const { defaultValue, name } = props;
  const [setSources, setSetSources] = useState<accordionData>([]);
  const [expanded, setExpanded] = useState(true);
  const toggleExpanded = () => setExpanded(prevState => !prevState);
  const handleClick = (source: string) => {
    return () => {
      setFilters({ source });
      setPageCursor(undefined);
      if (source === 'DevHub') {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };
  };

  const { loading, value } = result;

  useEffect(() => {
    if (term) {
      setFilters({ source: 'All' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);

  useEffect(() => {
    if (!loading) {
      if (filters?.source && filters.source === 'All') {
        const getFacets = (enterpriseResultSet: EnterpriseResultSet) => {
          if (enterpriseResultSet?.facets) {
            const sources = enterpriseResultSet.facets
              .filter(facet => facet.field === 'contentsource')
              .map(f => f.values)
              .flat()
              .map(val => {
                return {
                  name: val.value,
                  value: val.value,
                  icon: <CatalogIcon />,
                };
              });
            return sources;
          }
          return [];
        };
        setSetSources(getFacets(value!));
      }
    }
  }, [loading, value, filters]);

  // Handle any provided defaultValue
  useEffect(() => {
    if (defaultValue) {
      setFilters({ defaultValue });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const definedSources = [
    {
      value: 'All',
      name: 'All',
      icon: <AllIcon />,
    },
  ];
  definedSources.push(...setSources);

  // const selected = isSourceEmpty ? definedSources[0].name : filters?.source ?? definedSources[0].name;

  const selected = filters?.source ?? definedSources[0].name;

  return (
    <CustomSearchFilter
      name={name}
      label="Filter by Source"
      accordionData={definedSources}
      selected={selected as string}
      onClick={handleClick}
      toggleExpanded={toggleExpanded}
      expanded={expanded}
    />
  );
};
